import { useTranslation } from 'react-i18next'
import { Info } from 'lucide-react'
import { useTenant } from '../../context/TenantContext'

/**
 * Psychotherapy patient under 18: nothing to sign here — the guardians sign, with the minors flow
 * that comes later. The secretariat has been told (vertraege.stopped) and gets in touch.
 */
export function PtStopScreen() {
  const { t } = useTranslation()
  const { tenant } = useTenant()
  return (
    <div className="form-container">
      <div className="form-inner py-12 text-center">
        <Info className="w-10 h-10 text-primary mx-auto mb-4" />
        <h2 className="text-h2 text-foreground mb-3">{t('pt.stop.title')}</h2>
        <p className="text-body text-muted-foreground mb-6">{t('pt.stop.body')}</p>
        {tenant?.contactEmail && (
          <p className="text-small text-muted-foreground">
            {t('pt.stop.contact')} <a className="underline" href={`mailto:${tenant.contactEmail}`}>{tenant.contactEmail}</a>
          </p>
        )}
      </div>
    </div>
  )
}
